import React from "react";
import Modal from "./index";

export default function ShowHintModal({ show, onClose, strikes, triggerHint }) {
    return (
        <Modal show={show} onClose={onClose}>
            <h1>Need a hint?</h1>
            <p>
                A hint automatically puts the most popular answer into your snake. If you use a hint, it will count as a strike.
            </p>
            <p>Current Strikes: {strikes.length}/3</p>
            {strikes.length > 1 && <p style={{color:'red'}}>Using a hint will count as a strike causing you to lose...</p>}
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <button
                    style={{
                        padding: '10px 20px',
                        border: 'none',
                        borderRadius: '5px',
                        color: 'white',
                        cursor: 'pointer',
                        backgroundColor: '#e53935'
                    }}
                    onClick={() => {
                        triggerHint();
                    }}
                    disabled={strikes.length >= 2}
                >
                    Use Hint
                </button>
                <button
                    style={{
                        padding: '10px 20px',
                        border: 'none',
                        borderRadius: '5px',
                        color: 'white',
                        cursor: 'pointer',
                        backgroundColor: '#555'
                    }}
                    onClick={onClose}
                >
                    Cancel
                </button>
            </div>
        </Modal>
    );
}